var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "design-table" }, [
    _c("table", [
      _c("thead", { staticClass: "design-table-head" }, [
        _c(
          "tr",
          { staticClass: "design-table-head-tr" },
          [
            _c("th"),
            _vm._v(" "),
            _c("th"),
            _vm._v(" "),
            _c("th"),
            _vm._v(" "),
            _c("th", [_vm._v("C")]),
            _vm._v(" "),
            _c("th", [_vm._v("S")]),
            _vm._v(" "),
            _c("th", [_vm._v("H")]),
            _vm._v(" "),
            _c("th", [_vm._v("L")]),
            _vm._v(" "),
            _c("th", [_vm._v("P")]),
            _vm._v(" "),
            _c("th", [_vm._v("D")]),
            _vm._v(" "),
            _c("th", [_vm._v("Wt (Int")]),
            _vm._v(" "),
            _c("th", [_vm._v("Ext)")]),
            _vm._v(" "),
            _c("th", [_vm._v("BR")]),
            _vm._v(" "),
            _c("th", [_vm._v("SR")]),
            _vm._v(" "),
            _vm.se_design.refit_valid
              ? [
                  _c("th", [_vm._v("Refit BR")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Refit SR")])
                ]
              : _vm._e(),
            _vm._v(" "),
            _c("th", [_vm._v("Pwr Cost")]),
            _vm._v(" "),
            _c("th", [_vm._v("Pwr Gen")]),
            _vm._v(" "),
            _c("th", [_vm._v("O")]),
            _vm._v(" "),
            _c("th", [_vm._v("E")]),
            _vm._v(" "),
            _c("th", [_vm._v("T")]),
            _vm._v(" "),
            _c("th", [_vm._v("Build Time")]),
            _vm._v(" "),
            _c("th", [_vm._v("Year Available")])
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c(
        "tbody",
        { staticClass: "design-table-body" },
        [
          _c("PrincipalFrameFinal"),
          _vm._v(" "),
          _c("PrincipalFrameRaw"),
          _vm._v(" "),
          _vm._l(_vm.se_subsystems, function(se_subsystem) {
            return [
              _c(
                "tr",
                { key: se_subsystem.name, staticClass: "subsystem-spacer-row" },
                [_c("td", { attrs: { colspan: "100", height: "30px" } })]
              ),
              _vm._v(" "),
              _c("SubsystemFrame", {
                key: se_subsystem.name + "-frame",
                attrs: { se_subsystem: se_subsystem }
              }),
              _vm._v(" "),
              _c("SubsystemSummary", {
                key: se_subsystem.name + "-summary",
                attrs: { se_subsystem: se_subsystem }
              }),
              _vm._v(" "),
              _c("SubsystemSettings", {
                key: se_subsystem.name + "-settings",
                attrs: { se_subsystem: se_subsystem }
              }),
              _vm._v(" "),
              _vm._l(se_subsystem.components, function(se_component) {
                return [
                  _c("ComponentTr", {
                    key: se_component.name,
                    attrs: { se_component: se_component }
                  })
                ]
              })
            ]
          }),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c("ModuleTr", { attrs: { se_module: _vm.se_design.module } })
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "subsystem-spacer-row" }, [
      _c("td", { attrs: { colspan: "100", height: "30px" } })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7d86dec6", { render: render, staticRenderFns: staticRenderFns })
  }
}